import { render, staticRenderFns } from "./MonthlyChangeIndex.vue?vue&type=template&id=1dae8ef4"
import script from "./MonthlyChangeIndex.vue?vue&type=script&lang=js"
export * from "./MonthlyChangeIndex.vue?vue&type=script&lang=js"
import style0 from "./MonthlyChangeIndex.vue?vue&type=style&index=0&id=1dae8ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports